import { object, string } from "yup";
import { postCode } from "./postCode";

const errorMsg =
  "You must select an address from the dropdown menu to continue";

export const preciselyAddress = () =>
  object({
    label: string().required(errorMsg),
    value: object({
      formattedAddress: string().required(),
      streetName: string().required("Street name is missing"),
      city: string().required("City is missing"),
      country: string().required("Country is missing"),
      addressLastLine: string().required(),
      mainAddressLine: string().required(),
      state: string().required("State is missing"),
      addressNumber: string().nullable(),
      postCode: postCode(),
      lotUnit: string().nullable(),
    }),
  })
    .typeError(errorMsg)
    .required(errorMsg)
    .test({
      message: errorMsg,
      test: ({ value }) => !!value.formattedAddress,
    });
